export default __webpack_public_path__ + "static/media/logo-car.b3a203b8.webp";